// components/AdminView/EmployeeTabs.js
import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import EmployeeAttendance from "../EmployeeView/EmployeeAttendance";
import LeavesEmployee from "../EmployeeView/LeavesEmployee";
import UserAccountDeactivated from "../Attendance/UserAccountDeactivated";
import ViewAttendance from "./ViewAttendance";
import AssignSaturday from "./AssignSaturday";

export default function EmployeeTabs() {
  const [key, setKey] = useState("attendance");
const storedUser = localStorage.getItem("user");
const user = JSON.parse(storedUser);
  return (
    <div className="underline-tabs" style={{ paddingTop: "16px", paddingLeft: "16px", paddingRight: "16px" }}>
    <Tabs
      id="employee-tabs"
      activeKey={key}
      onSelect={(k) => setKey(k)}
      className="flex-nowrap"
    >
      <Tab eventKey="attendance" title="Attendance">
        <EmployeeAttendance />
      </Tab>
      <Tab eventKey="leaves" title="Leaves">
        <LeavesEmployee />
      </Tab>
       {(user.role === 4 || user.role === 2) && <Tab eventKey="view_attendance" title="View Attendance">
        <ViewAttendance />
      </Tab>}
      {(user.role === 4 || user.role === 2) && <Tab eventKey="assign_saturday" title="Assign Saturday">
        <AssignSaturday />
      </Tab>}
      {user.role === 4 && <Tab eventKey="deactivate_employee_account" title="Deactivated Accounts">
        <UserAccountDeactivated />
      </Tab>}
    </Tabs>
    </div>
  );
}
